var map = {
	"./en": [
		272,
		2
	],
	"./en.json": [
		272,
		2
	],
	"./es": [
		273,
		1
	],
	"./es.json": [
		273,
		1
	],
	"./zh-CN": [
		274,
		0
	],
	"./zh-CN.json": [
		274,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 393;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./resources/js/lang lazy ^\.\/.*$
// module id = 393
// module chunks = 19